<template>
	<div>
		<div class="gap-3 items-center flex items-center justify-start mb-[20px]">
			<div>
				<LucideIcon :name="icon" :size="26" :stroke-width="1.7" color="#302E81" />
			</div>
			<p class="text-lg font-medium text-[#302E81] -mb-1">{{title}}</p>
		</div>
	</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";

export default {
	name:"HeaderView",
	components:{
		LucideIcon
	},
	props:{
		title:{
			type:String
		},
		subText:{
			type:String
		},
		icon:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>